import React, { useEffect, useRef, useState} from 'react';
import { Calendar } from "primereact/calendar"
import './PayrollModal.css';
import moment from 'moment';
import LoadingSpinner from "../loadSpinner/LoadingSpinner.jsx";
import { Toast } from 'primereact/toast';
import { getPayrollByProjectListRequest, getProjectPayrollWeekly } from '../../services/wisdomServices/reportService.js';
import { requestCreateAuditLog } from '../../services/wisdomServices/auditService.js';
import { getSessionItem } from '../../utils/helper/session.js';
import { Button } from "primereact/button"
import { FloatLabel } from 'primereact/floatlabel';
import { Dialog } from 'primereact/dialog';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';
import { expFile } from '../../utils/helper/exports.js';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

/**
 * @function PayrollModal
 * @param {Object} props - component props
 * @param {Object} props.modalData - project data used to generate payroll
 * @param {Function} props.onCancel - callback to close the modal
 * @returns {JSX.Element} - payroll modal component
 */
function PayrollModal(props) {
  const toast = useRef(null)
  const myData = props.modalData
  let [payrollData,setPayrollData] = useState([]);
  let docElement = "";
  let [loading,setLoading] = useState(false);
  let [dates,setDates] = useState({
    fromDate : null,
    toDate : null,
  })
  const [filters, setFilters] = useState({
        global: {value:null, matchMode: FilterMatchMode.CONTAINS},
        name: {value:null, matchMode: FilterMatchMode.CONTAINS},
        role: {value:null, matchMode: FilterMatchMode.CONTAINS},
  })
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const globalFilters = ['name', 'role']
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  /**
   * @param {Date} date - selected start date
   */
  const setFromDate = (date) => {
    dates.fromDate = date;
    setDates({...dates});
    getPayrollDetails(dates.fromDate,dates.toDate);
    /*update the date */
  }
   /**
   * @param {Date} date - selected end date
   */
  const setToDate = (date) => {
    dates.toDate = date;
    setDates({...dates});
    getPayrollDetails(dates.fromDate,dates.toDate);
  }
  /**
   * @async
   * @function getPayrollDetails
   * @param {Date} from 
   * @param {Date} to 
   * @description -  fetches payroll details for the selected project and date range
   */
  const getPayrollDetails = async(from,to) =>   {
    if(from == null || to == null)
      return;
    setLoading(true);
    let keys = { "from":moment(from).format("YYYY-MM-DD") , "to": moment(to).format("YYYY-MM-DD"),"projectIds":[myData.id] };
    try {     
      let data = [];
      setPayrollData([]);
      let response = await getPayrollByProjectListRequest(keys.from, keys.to, keys.projectIds)
      let id = 1;
      for (const item of response) {
        data.push({
          id: id++,
          email: item.username,
          name: item.name,
          totalTracked: item.totalTime,
          productive: item.activeTime,
          manual: item.requested,
          idle: item.idleTime,
          payroll: item.payroll,
          project: item.project,
          eId : item.id,
          role: item.projectRole
        });
      }
      setPayrollData(data);
      setLoading(false);
    } catch(error) {
      console.error(`${new Date().toISOString()} - getPayrollDetails error: ${error}`)
    }
  }


  const columns = [
    {
      field: 'name',
      header: 'Name'
    },
    {
      field: 'role',
      header: 'Project Role',
    },
    {
      field: 'payroll',
      header: 'Payroll Time'
    },
  ];
  /**
   * @param {string} text - message to display
   */
  const showInfo = (text) => {
    toast.current.show({severity:'info', summary: 'Info', detail:text, life: 3000});
  }
  /**
   * @async
   * @function downloadHtml
   * @description - generates and downloads a payroll invoice file
   */
  let downloadHtml = async () => {
    try {
      let user = getSessionItem("User");
      let keys = { 
        from: moment(dates.fromDate).format("YYYY-MM-DD") , 
        to: moment(dates.toDate).format("YYYY-MM-DD"),
      };
      let response = await getProjectPayrollWeekly(keys.from, keys.to, myData.name)
      showInfo("Invoice generated")
      myData.payroll = response;
      myData.fromDate = dates.fromDate;
      myData.toDate = moment(dates.toDate).endOf('isoWeek').format("YYYY-MM-DD 00:00:00");
      myData.month = moment(dates.fromDate).month()+1;
      myData.year = moment(dates.fromDate).year();
      
      expFile(myData);

      let log = { 
        action: "download",
        entityType: "report",
        entityId : `formal docx invoice`,
        details : `[Requested by ${user.firstName} ${user.lastName}] - project: ${myData.name}, from: ${moment(dates.fromDate).format("YYYY-MM-DD")}, to: ${moment(dates.toDate).format("YYYY-MM-DD 23:59:59")}`, 
      };
      await requestCreateAuditLog(log);
      
    } catch (error) {
      console.error(error)
    }
  }

  const dialogHeader = (
    <div>
      <span><b>{myData.name}</b> - Invoice</span>
    </div>
  )

  const dialogFooter = (
    <div>
      <Button label='Close' onClick={props.onCancel} autoFocus/>
    </div>
  )

  const tableHeader = () => {
    return (
        <div className="project-invoice-table-header">
          <div>
            <Button label='Print invoice' icon="pi pi-file-word" severity="info" onClick={downloadHtml} disabled={payrollData.length <= 0}/>
          </div>         
          <div>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
            </IconField>
          </div>
        </div>
    );
  };
  
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
      props.onCancel(); 
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
        window.removeEventListener('keydown', handleKeyDown);
    };
  }, [props.onCancel])
  

  return (
    <Dialog
      dismissableMask
      visible={props.open}
      onHide={props.onCancel}
      header={dialogHeader}
      footer={dialogFooter}
      modal
      style={{minHeight:"765px", minWidth:"860px"}}
    >
      <Toast ref={toast} position='top-center'/>
      <div className='project-invoice-modal-box'>
        <div>
          <FloatLabel>
            <Calendar
              value={dates.fromDate}
              inputId='payroll-modal-from-date-picker'
              onChange={(e) => setFromDate(e.value)}
              maxDate={new Date()}
              dateFormat='dd/mm/yy'
            />
            <label htmlFor='payroll-modal-from-date-picker'>To date</label>
          </FloatLabel>
        </div>
        <div>
          <FloatLabel>
            <Calendar
              value={dates.toDate}
              inputId='payroll-modal-to-date-picker'
              onChange={(e) => setToDate(e.value)}
              maxDate={new Date()}
              disabled={dates.fromDate == null}
              dateFormat='dd/mm/yy'
            />
            <label htmlFor='payroll-modal-to-date-picker'>To date</label>
          </FloatLabel>
        </div>
      </div>
      <div>
        {!loading && (
          <DataTable 
            value={payrollData}
            loading={loading}
            header={tableHeader}
            filters={filters}
            rows={5}
            globalFilterFields={globalFilters}
          >
            {columns.map((column, i) => {
              return(
                <Column 
                    key={column.field}
                    field={column.field} 
                    header={column.header} 
                    body={column?.body}
                    bodyStyle={column?.bodyStyle}
                    headerStyle={column?.headerStyle}
                />
              )
            })}
          </DataTable>
        )}
        {loading && (
          <LoadingSpinner/>
        )}
      </div>
      <div id="docElement" >
          {docElement}
      </div>
    </Dialog>
  );
}

export default PayrollModal;
